import { useState } from 'react'

export const usePersistedState = <T>(
  name: string,
  defaultValue?: T
): [T, (arg: (prev: T) => T) => void] => {
  const persisted = localStorage.getItem(name)
  const [value, setValue] = useState<T>(persisted ? JSON.parse(persisted) : defaultValue)

  return [
    value,
    (setter) => {
      const next = setter(value)
      localStorage.setItem(name, JSON.stringify(next))
      setValue(next)
    }
  ]
}
